import { Component, OnInit, Inject, PLATFORM_ID, AfterViewInit, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NeproseService } from 'src/app/services/neprose.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { WindowRef } from 'src/app/Window/WindowRef';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import {NgxGalleryOptions} from '@kolkov/ngx-gallery';
import {NgxGalleryImage} from '@kolkov/ngx-gallery';
import {NgxGalleryAnimation} from '@kolkov/ngx-gallery';
import { AuthService } from 'src/app/services/auth.service';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

declare const google: any;

@Component({
  selector: 'app-property-admin-preview',
  templateUrl: './property-admin-preview.component.html',
  styleUrls: ['./property-admin-preview.component.css']
})
export class PropertyAdminPreviewComponent implements OnInit {

  adId: any

  property: any

  url: string

  provinceList = []

  districtList = []

  municipalityList = []

  address: any

  seller: Observable<any>

  galleryOptions: NgxGalleryOptions[]

  galleryImages: NgxGalleryImage[] = []

  otherFacilities = []

  @ViewChild('mapContainer', {static: false}) gmap: ElementRef;

  map: google.maps.Map;

  coordinates: any

  mapOptions: google.maps.MapOptions

  marker: any

  similarProperties = []

  backgroundImageURL: any = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/colony.jpg'})`+` no-repeat center center`)

  loggedIn: boolean 

  notFavourite: boolean = true

  favourite: any

  token: any

  seoData: SeoSocialShareData = {
    title:  'Property Preview',
    description: 'Your next real estate investment opportunity could be right around the corner.',
    image: environment.url+'/assets/logo.png'
  };

  mapLoaded: boolean

  constructor(private route: ActivatedRoute, private _neproseService: NeproseService, @Inject(PLATFORM_ID) protected platformId: Object, private _ngZone: NgZone,
  private _sanitizer: DomSanitizer, private cdr: ChangeDetectorRef, private _authService: AuthService, private _router: Router, private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.adId = this.route.snapshot.params.id
    this.route.data.subscribe((data: { provinceList: any, districtList: any, municipalityList: any, propertyAd: any }) =>{
      this.provinceList = data.provinceList.provinces
      this.districtList = data.districtList.districts
      this.municipalityList = data.municipalityList.municipalities  
      this.property = data.propertyAd.propertyAd 
      this.route.queryParams.subscribe(params => {
        if(params.token){
          this.token = params.token
          this._neproseService.checkAdmin(this.token).subscribe(data => {
            if(data.status){
              this.handleRouteChanges()
            }
          }, error => {
            this._router.navigate(['404'])
          })
        }else{
          this._router.navigate(['404'])
        }
      })
    })
  }

  setGalleryOptions(){
    this.galleryOptions = [
        { 
          width: '100%', 
          height: '70vh', 
          "imageArrowsAutoHide": true, 
          "thumbnailsArrowsAutoHide": true , 
          "thumbnailsRemainingCount": true,
          
        },
        { "breakpoint": 500, "width": "100%", "height": "300px", "thumbnailsColumns": 3 },
        { "breakpoint": 300, "width": "100%", "height": "200px", "thumbnailsColumns": 2 }
      ]
  }


  handleRouteChanges(){  
    this.setGalleryOptions()
    this.adId = this.route.snapshot.params.id
    this.url = environment.url + '/property/' + this.adId
    this.prepareAdvertisement() 
    this.cdr.detectChanges()
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.mapInitializer()
        this.cdr.detectChanges()
      }, 2000)
    })   
  } 

  mapInitializer() {
    if(isPlatformBrowser(this.platformId)){
      this.coordinates  = new google.maps.LatLng(this.property.latitude, this.property.longitude)
      this.mapOptions = {
          center: this.coordinates,
          zoom: 14
      }
      this.marker = new google.maps.Marker({
          position: this.coordinates,
          map: this.map,
      })
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions)
      this.marker.setMap(this.map)
      this.mapLoaded = true
    }
  }

  prepareAdvertisement(){
    this.property.title = this.property.title.toUpperCase()
    let district = this.districtList.find(district => district.id == this.property.district_id)
    let municipality = this.municipalityList.find(municipality => municipality.id == this.property.municipality_id)
    this.address = municipality.municipality+', '+district.district
    if(this.property.village){
      this.address = this.property.village+', '+this.address
    }
    this.getSeller()
    if(this.property.otherFacilities){
      this.otherFacilities = JSON.parse(this.property.otherFacilities)
    }
    if(this.property.PropertyImage){
      let propertyImages = JSON.parse(this.property.PropertyImage.imagePath)
      if(propertyImages.length > 0){
        this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+propertyImages[0]})`+` no-repeat center center`)
        for(let image of propertyImages){
          this.galleryImages.push(
            {
              small: environment.api+'/images/'+image,
              medium: environment.api+'/images/'+image,
              big: environment.api+'/images/'+image,
            }
          )
        }
      }
    }
    //Nepali Style comma separated number for price
    let lastThree = this.property.price.toString().substring(this.property.price.toString().length-3);
    let otherNumbers = this.property.price.toString().substring(0,this.property.price.toString().length-3);
    if(otherNumbers != '')
        lastThree = ',' + lastThree;
    this.property['price'] = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    //End
  }

  getSeller(){
    this.seller = this._neproseService.getSeller(this.property.user_id).pipe(share())
  }

}
